import React from "react";
import { getIn } from "formik";

export default class Radio extends React.Component<any, any> {
  render() {
    const {
      field,
      form: { errors, touched },
      list = [
        [true, "Yes"],
        [false, "No"],
      ],
      wrapper,
      ...props
    } = this.props;
    const error = getIn(touched, field.name) && getIn(errors, field.name);

    return (
      <>
        {list.map((item: any) => {
          const name = `${field.name}_${item[0]}`;

          return (
            <span key={item[0]} {...wrapper}>
              <input
                id={name}
                {...field}
                {...props}
                value={item[0]}
                type="radio"
                checked={field.value?.toString() === item[0].toString()}
              />
              &nbsp;
              <label htmlFor={name} className="pointer">
                {item[1]}
              </label>
            </span>
          );
        })}
        {error && <span className="text-danger">{error}</span>}
      </>
    );
  }
}
